module.exports = __webpack_public_path__ + "media/images/cardholder-idv-icon-3d1e44125eb69ae895c9a113ab47335a.svg";